/** 密码输入 */
import React, { FC, useState } from 'react'
import { IonInput, IonIcon, useIonViewWillEnter } from '@ionic/react'
import { eyeOutline, eyeOffOutline } from 'ionicons/icons'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { validPassword } from '@utils'
import './index.scss'

interface IProps {
  onChange?: ({ inputValue, valid }: { inputValue: any; valid: any }) => any;
}
interface IState {
  value: string;
  visible: boolean;
}

const PasswordInput: FC<IProps> = (props) => {
  const {
    onChange
  } = props
  const initialState: IState = {
    value: '',
    visible: false
  }
  const [value, setValue] = useState(initialState.value)
  const [visible, setVisible] = useState(initialState.visible)
  // value change
  const handleChange = (val: any) => {
    setValue(val)
    onChange && onChange({
      inputValue: val,
      valid: validPassword(val)
    })
  }
  // Component Effect
  useIonViewWillEnter(() => {
    setValue(initialState.value)
    setVisible(initialState.visible)
  })
  return (
    <div className='mkt-pass-input'>
      <IonInput maxlength={20} data-cypid='mktPassInput' type={visible ? 'text' : 'password'} value={value} placeholder={i18n.t('mkt.common.tipPassword2')} onIonChange={e => handleChange(e.detail.value)}></IonInput>
      <span className='visible' data-cypid='mktPassInputShow' onClick={() => setVisible(!visible)}>
        <IonIcon className='icon' icon={visible ? eyeOutline : eyeOffOutline} />
      </span>
    </div>
  )
}

export default observer(PasswordInput)
